'use strict'

module.exports = ['en', 'de', 'fr', 'fr-BE', 'nl', 'nl-BE']
